import { render, staticRenderFns } from "./reservaUsa.vue?vue&type=template&id=4b64cd4c&"
import script from "./reservaUsa.vue?vue&type=script&lang=js&"
export * from "./reservaUsa.vue?vue&type=script&lang=js&"
import style0 from "./reservaUsa.vue?vue&type=style&index=0&id=4b64cd4c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports